import { render, staticRenderFns } from "./safeRight.vue?vue&type=template&id=27c295f0&scoped=true&"
import script from "./safeRight.vue?vue&type=script&lang=js&"
export * from "./safeRight.vue?vue&type=script&lang=js&"
import style0 from "./safeRight.vue?vue&type=style&index=0&id=27c295f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c295f0",
  null
  
)

component.options.__file = "safeRight.vue"
export default component.exports